import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=04336f40&scoped=true"
import script from "./Generate.vue?vue&type=script&lang=ts"
export * from "./Generate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04336f40",
  null
  
)

export default component.exports